import { SortOptions } from './common';

export const HeaderLogoIcons = {
  tavern: '/img/icons/tavern.png',
  flipCoin: '/img/icons/flipCoin.png',
  pusher: '/img/icons/pusher.png'
};

export const SortOptionsLabels = {
  [SortOptions.ASC]: 'highBet',
  [SortOptions.DESC]: 'lowBet',
  [SortOptions.DATE]: 'byDate'
};
